<template>
<div>

<v-dialog max-width="500" min-width="500" v-model="dialogVisible" :fullscreen="$vuetify.breakpoint.smAndDown" transition="v-fade-transition" :hide-overlay="false" scrollable>
<div :style="{height: dialogHeight}" class="dialog-container" style="width:100%">

    <div class="dialog-header">
        <v-toolbar dark flat dense class="primary">
            <v-toolbar-title class="white--text">{{title || 'Select a Contact'}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click.native="toggleAdding" icon>
                <v-icon v-if="adding">list</v-icon>
                <v-icon v-else>add</v-icon>
            </v-btn>
        </v-toolbar>
    </div>

    <div class="dialog-body">
        <div class="pa-4" v-if="adding">
            <ContactDetails ref="contactDetails" :contact="contact"/>
        </div> 
        <template v-else>
            <ContactSearch :role="data.role" :visible="dialogVisible" @click="select" @add="toggleAdding"/>
        </template>              
    </div>

    <div class="dialog-footer">

        <!-- <template v-if="data.role">
            <v-btn style="float:left;" flat @click.native="showAllContacts">Show all Contacts</v-btn>                
        </template>         -->
        <template v-if="adding">
            <v-btn text @click.native="saveAndSelect">Save and Select</v-btn>                
            <v-btn text @click.native="clickedCancel">Cancel</v-btn>
        </template>

        <template v-else>
            <v-btn text @click.native="clickedCancel">Cancel</v-btn>
        </template>
    </div>
    
</div> 
</v-dialog>

</div>
</template>

<script>
    import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
    import FirebaseHelpers from '../helpers/FirebaseHelpers'
    import StringHelpers from '../helpers/StringHelpers'
    import ContactHelpers from '../helpers/ContactHelpers'
    import ContactSearch from './ContactSearch'
    import ContactDetails from './ContactDetails'
    import DataHelpers from '../helpers/DataHelpers'
    // import {debounce, union} from 'underscore'

    var db = firebase.database()

    
    export default {
    props:{
        visible: Boolean,
        data: Object,
        title: String
    },
    components:{
        'ContactSearch': ContactSearch,
        'ContactDetails': ContactDetails
    },
    data() {
        return {
            dialogVisible: this.visible,
            adding: false,
            contact: null
        }
    },

    computed: {
        tenantKey() {
            return this.$store.getters.tenantKey
        },
        dialogHeight() {
            if(this.$vuetify.breakpoint.smAndDown)
                return '100%'
            else
                return '500px'
        },


        contactDialogImageVisible () {
            if(this.contact.image && 
            this.contact.image.indexOf('transparent') < 0)
                return true
            else
                return false
        },
        contactImage () {
            if(this.contact.image)
                return this.contact.image
            else    
                return '/static/images/transparent.png'
        }
    },
    methods: {
        toggleAdding() {
            this.adding=!this.adding
            if(this.adding) {
                this.contact.meta = {
                    tenantKey: this.tenantKey
                }
            }
        },
        saveAndSelect () {

            if(!this.$refs.contactDetails.validate())
                return

            let vm = this
            let ref = DataHelpers.getTenantRef(this.tenantKey).child('contacts')
            
            ref.push(this.contact)
            .then((snap) => {
                vm.contact.meta = {}
                vm.contact.meta.key = snap.key
                vm.contact.meta.tenantKey = this.tenantKey
                vm.select(vm.contact)
            })
        },
        select(contact) {
            this.$emit('select', contact, this.data)
        },
        clickedCancel() {
            this.$emit('cancel')
        },

        initialiseDialog () {
            this.adding = false
            //this.search = ''
            this.contact = {
                image: '/static/images/transparent.png',
            }
            //this.loadContacts()
            //this.$store.dispatch('fetchContacts', '')
        },
        checkGender() {
            ContactHelpers.setInitialGender(this.contact)
        },
        showAllContacts() {
            this.data.role = null
        }
    },
    watch: {
        visible: function (newVal) {
            this.dialogVisible = newVal
            if(newVal)
                this.initialiseDialog()
        },

        // 'search': function(newVal) {
        //     this.runSearch(newVal)
        // },

    },
    created () {
        this.initialiseDialog()
    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// ContactSelector.vue?13d690a2